import React, { useEffect, useState } from 'react';
import { useForm, SubmitHandler, Controller } from 'react-hook-form';
import Input from '../../../components/elements/form/input';
import Teaxtarea from '../../../components/elements/form/textarea';
import SelectBox from '../../../components/elements/form/selectBox';
import Button from '../../../components/elements/button';
import Icon from '../../../components/icons';
import { useAppLoader } from '../../../_common/pageLoader/appLoaderHook';
import { useSpearPartsApi } from '../../../store/api/hooks/spearPartsApiHook';
import toast from 'react-hot-toast';
import { MASTER_DROPDOWN_PAGE_SIZE } from '../../../_common/constant';
import { useAssetsApi } from '../../../store/api/hooks/assetsApiHook';
import { getSelectedOption, localDate } from '../../../_common/functions';
import FileUpload from '../../../components/elements/form/fileUplaod';
import { Link, useParams } from 'react-router-dom';
import { useDialog } from '../../../store/api/hooks/dialogHook';
import { useFacilitiesApi } from '../../../store/api/hooks/facilitiesApiHook';
import Datepicker from '../../../components/elements/form/datepicker';

interface FormProps {
    _ref?: any;
    fromList?: any
    editData?: any;
    onCreate?: () => void
    onCancel?: () => void
    show?: boolean;
}
type FormValues = {
    assetDetailsID: any;
    partsID: any;
    quantity: any;
    
};


const CreatePart: React.FC<FormProps> = ({ _ref, editData, fromList, onCreate = () => { }, onCancel = () => { } , show}) => {
    const { control, register, handleSubmit, setValue, watch, getValues, formState: { errors }, reset } = useForm<FormValues>();
    const spearPartsAPI = useSpearPartsApi();
    const facilityApi: any = useFacilitiesApi();
    const assetAPI: any = useAssetsApi();
    const { showLoader, hideLoader } = useAppLoader();
    const { confirm } = useDialog();
    const params: any = useParams();
    const [vendorList, setVendorList] = React.useState<any[]>([]);
    const [unitList, setUnitList] = React.useState<any[]>([]);
    const [warrantyTermList, setWarrantyTermsList] = React.useState<any[]>([]);

    const [working, setWorking] = useState<boolean>(false);
    const [changeDate, setChangeDate] = useState<boolean>(false);
    const [partsImg, setPartsImg] = useState<any>(null);
    const [partsAttachment, setPartsAttachment] = useState<any>(null);
    const [attachmentList, setAttachmentList] = React.useState<any[]>([]);

    console.log('SHOW~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~', show);


    let imgExt = ['.png', '.jpg', '.jpeg', '.webp'];


    const formReset = () => {

        reset({

          
    partsID: '',
    quantity:''

        });
     
    }


    const onSubmit: SubmitHandler<FormValues> = data => {
        console.log("Submited data=================", data)
        setWorking(true);
        let payload: any = {


           
            "partsID": data.partsID?.value,
            "quantity": data.quantity,
          
            "assetID" : params.id
        }
        if (fromList) {

            payload['assetDetailsID'] = editData.assetDetailsID;
        } 

        if (editData && !fromList) {
            payload['warrantyID'] = editData.warrantyID;
        }

        showLoader();
        assetAPI.SaveAssetDetails(payload, (resp: any) => {
           
                onCreate();
                onCancel();
                console.log(resp, "Submited resp")
                if (resp?.successful === false) {
                    toast.error(resp?.message);
                      formReset();
                    hideLoader();
                    setWorking(false);
                    return;
                }
                toast.success(resp?.message)
                formReset();
                hideLoader();
                setWorking(false);
          


        }, (error: any) => {
            console.log('error =>', error);
            hideLoader();
           // toast.error(error);
            setWorking(false);
        });
    };



    // useEffect(() => {
    // 	if (_ref?.current) {
    // 		_ref.current.reset = formReset;
    // 	}
    // }, [_ref])

    useEffect(() => {
        if (editData && !fromList) {

            reset({

              

                // warrantyImage: editData.imageFullPath
            });
            const payload: any = {
                warrantyID: editData?.warrantyID
            }


        



        } else {
            formReset();
            setAttachmentList([]);
            if (_ref?.current) {
                _ref.current.reset = formReset;
            }
        }
    }, [_ref, editData, vendorList, warrantyTermList,]);



    const savePartsImage = (data: any) => {
        showLoader();
        assetAPI.SaveAssetWarrantyAttachment(data, (resp: any) => {
            onCreate();
            onCancel();
            console.log(resp, "Submited resp")
            toast.success(resp?.message)
            formReset();
            hideLoader();
            setWorking(false);
        }, (error: any) => {
            hideLoader();
          ///  toast.error(error);
            setWorking(false);
        });
    }



   




    const getvenderList = () => {
        showLoader();
        assetAPI.GetvenderList({ pageSize: MASTER_DROPDOWN_PAGE_SIZE, pageNumber: 1 }, (resp: any) => {
            const vendorList = (resp?.vendorList?.map((item: any) => {
                return {
                    label: item.name,
                    value: item.vendorID
                }
            }));
            setVendorList(vendorList);
            hideLoader();
        }, (error: any) => {
            setVendorList([]);
            hideLoader();
        });
    }
    const GetWarrantyTermList = () => {
        showLoader();
        assetAPI.GetWarrantyTermList({ pageSize: MASTER_DROPDOWN_PAGE_SIZE, pageNumber: 1 }, (resp: any) => {
            const vendorList = (resp?.warrantyTermList?.map((item: any) => {
                return {
                    label: item.warrantyTermName,
                    value: item.warrantyTermsID
                }
            }));
            setWarrantyTermsList(vendorList);

            hideLoader();
        }, (error: any) => {
            setWarrantyTermsList([]);
            hideLoader();
        });
    }


    useEffect(() => {

        getvenderList();
        GetWarrantyTermList();


    }, []);
   


    return (
        <form onSubmit={handleSubmit(onSubmit)} ref={_ref} className='flex flex-col h-full'>
            <div className='flex-1 overflow-auto'>
                <h4 className='font-semibold text-[0.938rem] pb-4 uppercase'>Basic Information</h4>

<Controller
                name="partsID"
                control={control}
                render={({ field: { value, onChange } }) => (

            	<SelectBox
								className="mt-2"
                             label="Part Name"   
								async={true}
								value={value}
                                isClearable={true}
								onChange={onChange}
								placeholder="search part here"
								asyncLoadOptions={(value: string) => {
									return new Promise((resolve, reject) => {
										spearPartsAPI.getSpearPartsList(
											{
												pageSize: 20,
												pageNumber: 1,
												searchParam: value,
											},
											(data: any) => {
												// console.log("Part Data", data)
												resolve(
													data.sparePartsList.map((part: any) => {
														return {
															label: part.sparePartsName + ` (${part.partsCode})`,
															value: part.partsID,
															partDetails: part,
														};
													})
												);
											},
											(error: any) => {
												reject(error);
											}
										);
									});
								}}
							/>

                            )}
                            />

                            
<Controller
                name="quantity"
                control={control}
                render={({ field: { value, onChange } }) => (

                            <Input
                            label="Quantity"  
										
										className="mt-2"
										type="number"
										value={value}
										onChange={(e) => {
											const value = Number(e.target.value);
											if (value < 0) {
												toast.error("Value cannot be negative");
												return;
											}
                                            onChange(e.target.value)
											

										
										}}
									/>

                                     )}
                            />

                


            </div>
            <div className='flex justify-end gap-2 flex-shrink-0 border-t border-gray-200 pt-2'>
                <Button type="button" theme='secondary' working={working} onClick={() => {
                    formReset();
                    onCancel();
                }}>Cancel</Button>
                <Button type="submit" working={working}>Save</Button>
            </div>

            {/* <input id="assetName" {...register('assetName', { required: true })} />
            {errors.assetName && <span>This field is required</span>}

            <div>
                <label htmlFor="assetType">Asset Type</label>
                <input id="assetType" {...register('assetType', { required: true })} />
                {errors.assetType && <span>This field is required</span>}
            </div>

            <div>
                <label htmlFor="purchaseDate">Purchase Date</label>
                <input id="purchaseDate" type="date" {...register('purchaseDate', { required: true })} />
                {errors.purchaseDate && <span>This field is required</span>}
            </div> */}

            {/* <button type="submit">Create Asset</button> */}
        </form>
    );
};

export default CreatePart;